module.exports = __webpack_public_path__ + "media/tr_tr_s4_Yusuf.69243ef0.oga";